import { getEditorStateFromHtml } from '../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/utils'
import { escapeHtml, getUserDisplayName } from '../../apps/professional-app/fa/common/aifeatures/utils'
import { stripToText } from '../../common/util'

import { Task, TaskStatus } from '../../models/MeetingSupport'
import { User } from '../../models/User'

export const USER_DROPDOWN_PLACEHOLDER = 'Select person\u2026'

export const zocksUserToSelectOption = (user: User) => {
  return {
    id: user.id,
    label: getUserDisplayName(user),
  }
}

export const getLexicalValue = (task: Task) => {
  const { task: subject, description } = task
  const descriptionText = description
    ? stripToText(description.replace(/<\/(p|li|div|h[1-6]|blockquote|td|th|tr)>|<br\s*\/?>/gi, '$& '))
        .replace(/\s+/g, ' ')
        .trim()
    : ''
  const descriptionHtmlValue = descriptionText ? `: ${escapeHtml(descriptionText)}` : ''
  const htmlValue = `<p><strong>${escapeHtml(subject)}</strong>${descriptionHtmlValue}</p>`
  const editorState = getEditorStateFromHtml(htmlValue).toJSON()
  return JSON.stringify(editorState)
}

export const isTaskDone = (task: Task) => task.status === TaskStatus.CLOSED || task.syncStatus.length > 0
